import React from 'react'

import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import { Content } from '@/components/Rankings/style.css'
import { Columns } from '@/components/Article/style.css'
import Summary from '@/components/Summary'
import data from '@/components/Feature/Rankings/Data'
import Ranking from '@/components/Feature/Rankings/Ranking'
import TitleSelector from '@/components/Feature/Rankings/TitleSelector'
import { CalidadDeLaInvestigacion } from '@/components/Feature/Rankings/Output'

const IndexPage = () => {
  const rankings = data.filter(item => item.name === 'Rankings')[0].rankings
  const datalocal = rankings.find(
    item =>
      item.link ===
      '/rankings-generales/percepcion-de-calidad-de-la-investigacion/',
  )

  return (
    <Layout>
      <SEO
        title={datalocal.name}
        keywords={[
          `La Tercera`,
          `${datalocal.name}`,
          `Ranking de Universidades Chilenas 2021`,
        ]}
      />
      <Content>
        <TitleSelector
          pretitle="Ranking de Universidades 2021"
          allRankings={rankings}
          section="rankings-generales"
          sectionSlug={datalocal.slug}
        />
        <Columns>
          <p>
            Este año, incorporamos un nuevo indicador en el ranking de
            investigación: el porcentaje de trabajos que una institución publica
            en las revistas científicas que se ubican en el 25% más alto de cada
            categoría de conocimiento, denominado Q1. Este cambio responde a que
            registrar el nivel de investigación que se desarrolla en un país,
            especialmente en uno como el nuestro, donde más del 90% de la
            investigación se realiza en las universidades, es un desafío, pues
            varios son los indicadores que intentan dar cuenta de su calidad. A
            este indicador se suman el número de publicaciones (output) y el
            impacto que éstas tienen en la comunidad científica internacional
            (impacto normalizado). Eso sí, la información sigue siendo extraída
            del Ranking Iberoamericano de Instituciones de Educación Superior,
            SIR Iber 2021, que elabora, desde 2009, SCImago Research Group. Pese
            a este ajuste, al igual que el año pasado, las universidades de
            Chile, Católica, Santa María, de Concepción y Diego Portales siguen
            en los primeros puestos de tabla. Entre los 10 primeras casas de
            estudio, destaca la Andrés Bello, ya que sus 3.336 papers la
            instalan como la universidad privada con más publicaciones. Y si de
            impacto se trata, a la Santa María, plantel que siempre ha liderado
            este indicador, este año se le suma la Diego Portales, ambas
            presentan un impacto normalizado de 1,7, lo que en la práctica
            significa que sus publicaciones son citadas un 70% más que la media
            mundial. Por otra parte, un 60% de los trabajos de la U. de La
            Serena son publicados en revistas que pertenecen al Q1, a ella le
            siguen, con más del 55%, las investigaciones de las universidades de
            Magallanes, Andrés Bello, de Antofagasta y Católica.
          </p>

          <p>
            Más del 55% de los trabajos de las universidades de La Serena, de
            Magallanes, Andrés Bello, de Antofagasta y Católica son publicados
            en revistas del Q1.
          </p>

          <p>
            Las investigaciones de la U. Técnica Federico Santa María y la U.
            Diego Portales son citadas un 70% por encima del promedio mundial de
            citación.
          </p>
        </Columns>
        <CalidadDeLaInvestigacion />
        <Summary />
      </Content>
    </Layout>
  )
}

export default IndexPage
